import { dataAPI } from "../api"

export const getConcept = (id: number): Promise<Resources.Concept> =>
    dataAPI
        .getJSON<Api.ODataGetResourceResponse<Api.ConceptResource>>(
            `concepts(${id})?$expand=workspace`,
        )
        .then((Concept) => {
            const { Workspace } = Concept
            const newConcept: Resources.Concept = {
                id: Concept.Id,
                title: Concept.Label,
                doesExist: true,
                workspace: {
                    id: Workspace.Id,
                    title: Workspace.Label,
                    doesExist: true,
                },
            }

            return newConcept
        })
